import React, { forwardRef, useId } from "react";

export const Input = forwardRef(({ className, title, value, onChange, marginTop = "mt-2", type, required, ...otherProps }, ref) => {
    const id = useId();
    return (
        <div className={marginTop}>
            {title && (
                <label
                    htmlFor={id}
                    className="block font-medium text-gray-900"
                >
                    {title}
                </label>
            )}
            <input
                id={id}
                ref={ref}
                value={value}
                onChange={onChange}
                type={type || "text"}
                required={required}
                {...otherProps}
                //@ts-ignore
                onWheel={(e) => e.target.blur()}
                className={`
                    block w-full appearance-none rounded-xl border border-gray-400 px-3 py-2 
                    placeholder-gray-400 shadow-xs focus:border-app_primary text-gray-800
                    focus:outline-none focus:ring-app_primary focus:ring-1 text-sm
                    ${className ? className : ""}
                `}
            />
        </div>
    );
});
//# sourceMappingURL=input.jsx.map
